// extracted by mini-css-extract-plugin
export default {"wrapper":"profile_wrapper__sPW8n","tabs":"profile_tabs__cD747","tabs_container":"profile_tabs_container__m-Qbd","cta":"profile_cta__G28Q0","active":"profile_active__BgvoK"};